import { TypeGroupIds } from './../../../modules/shared/constants/category-groupid.constants';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

import { TreeNode } from 'primeng/api';
import { AccountUserService } from 'src/app/service/account.service';
import { GalleriaThumbnails } from 'primeng/galleria';
import { AccountService } from 'src/app/accounts/accountService';
import { terriEnum } from 'src/app/more/territory/model/territoryEnum';
import { AddRootTerritory } from '../model/addRootTerritory';
@Injectable({
    providedIn: 'root'
})
export class TerriService {
    terriTemp;
    user;
    appUrl = "";
    territoryurl = ""
    leadAPI = ''
    activityUrl="";
    apiUrlLogin="";
    apiUrlOrganization="";
    accountApiUrl = '';

    private headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    constructor(private http: HttpClient, private accountUserService: AccountUserService) {
        this.accountUserService.user.subscribe(x => this.user = x);
        ////console.log(this.accountUserService.user);
        this.appUrl = environment.localApiUrl;
        this.territoryurl = environment.territoryURL;
        this.leadAPI = environment.apiUrlNew + "Lead/";
        this.activityUrl=environment.activity;
        this.apiUrlOrganization=environment.appOrgUrl;
        this.apiUrlLogin = environment.apiUrlLogin;
        this.accountApiUrl = environment.apiUrlAccount + "Account/";
    }

    getOrganizationDetails(organizationId) {
        return this.http.get<any>(environment.appOrgUrl+"organization/"+organizationId)
            .toPromise()
            .then(res => res);
    }

    getTerritoryUsers() {
        return this.http.get<any>(environment.appOrgUrl+"User/AllTerritoryUsers")
            .toPromise()
            .then(res => res);
    }

    getUserTypeDetails() {
        let randomstr = localStorage.getItem("randomstr");

        let headers_n = new HttpHeaders({
            'organizationId': this.user.organizationId + ''
            ,
            'userId': this.user.userId + '',
            // 'loginAuditId': this.user.loginAuditId + '',
            //  'authToken': this.user.token + '',
            // 'sessionId': randomstr,
            // 'sourceType': 'Web'
        });
        return this.http.get<any>(this.territoryurl+"Type?groupId="+TypeGroupIds.UserTypesTerritoryAPI,{
            headers: headers_n
        })
            .toPromise()
            .then(res => res);
    }

    getLoggedUser(userId) {
        return this.http.get<any>(this.appUrl + 'users/' + userId)
            .toPromise()
            .then(res => res);
    }
    updateUser(user) {
        return this.http.put(this.appUrl + 'users/' + user.id, user, { headers: this.headers })
            .toPromise()
            .then(() => user);
    }
    getUsers() {
        return this.http.get<any>(this.appUrl + 'users/')
            .toPromise()
            .then(res => res);
    }

    loadFieldList(templateId, objectId){
        return this.http.get<any>(`${environment.configUrl}Configuration/Field/${templateId}?objectId=${objectId}`)
    }
    getAccountColumnsSetings(templateId, objectId) {
        return this.http.get<any>(`${environment.configUrl}Configuration/ColumnSetting/${templateId}?objectId=${objectId}`)
      }
    addTerritory(territory) {
        let randomstr = localStorage.getItem("randomstr");
        let headers_n = new HttpHeaders({
        organizationId: `${this.user.organizationId}`,
        userId: `${this.user.userId}`,
        loginAuditId: `${this.user.loginAuditId}`,
        authToken: `${this.user.token}`,
        sessionId: `${randomstr}`,
       sourceType: `${'Web'}`
        });
       // https://localhost:44377/LionO360/2.0/API/Territory/
        return this.http.post<any>(this.territoryurl+"Territory/", territory, {
        //return this.http.post<any>(this.territoryurl+"Territory", territory, {
            headers: headers_n
        })
            .toPromise()
            .then(res => res);
    }

    deleteTerri(territoryId) {
        let randomstr = localStorage.getItem("randomstr");
        let headers_n = new HttpHeaders({
            'organizationId': this.user.organizationId + ''
            ,
            'userId': this.user.userId + '',
            // 'loginAuditId': this.user.loginAuditId + '',
            //  'authToken': this.user.token + '',
            // 'sessionId': randomstr,
            // 'sourceType': 'Web'
        });
        return this.http.delete<any>(this.territoryurl+"Territory/"+territoryId, {
            headers: headers_n
        })
            .toPromise()
            .then(res => res);
    }


    assignPermissionTerritory(territory) {
        let randomstr = localStorage.getItem("randomstr");
        let headers_n = new HttpHeaders({
            'organizationId': this.user.organizationId + ''
            ,
            'userId': this.user.userId + '',
            // 'loginAuditId': this.user.loginAuditId + '',
            //  'authToken': this.user.token + '',
            // 'sessionId': randomstr,
            // 'sourceType': 'Web'
        });
        return this.http.post<any>(this.territoryurl+'Territory/Assign', territory, {
            headers: headers_n
        })
            .toPromise()
            .then(res => res);
    }
    updateTerritory(territory) {
        let randomstr = localStorage.getItem("randomstr");
        let headers_n = new HttpHeaders({
            'organizationId': this.user.organizationId + ''
            ,
            'userId': this.user.userId + '',
            // 'loginAuditId': this.user.loginAuditId + '',
            //  'authToken': this.user.token + '',
            // 'sessionId': randomstr,
            // 'sourceType': 'Web'
        });
        return this.http.put<any>(this.territoryurl + "Territory", territory, {
            headers: headers_n
        })
            .toPromise()
            .then(res => res);
    }
    addComment(territory) {
        let randomstr = localStorage.getItem("randomstr");
        let headers_n = new HttpHeaders({
            'organizationId': this.user.organizationId + ''
            ,
            'userId': this.user.userId + '',
            // 'loginAuditId': this.user.loginAuditId + '',
            //  'authToken': this.user.token + '',
            // 'sessionId': randomstr,
            // 'sourceType': 'Web'
        });
        return this.http.post<any>(this.activityUrl+'/LionO360/2.0/API/ObjectNote', territory, {
            headers: headers_n
        })
            .toPromise()
            .then(res => res);
    }
    deleteContact(removeuserId) {
        let randomstr = localStorage.getItem("randomstr");
        let headers_n = new HttpHeaders({
            'organizationId': this.user.organizationId + ''
            ,
            'userId': this.user.userId + '',
            // 'loginAuditId': this.user.loginAuditId + '',
            //  'authToken': this.user.token + '',
            // 'sessionId': randomstr,
            // 'sourceType': 'Web'
        });

        return this.http.delete<any>(this.territoryurl+"Territory/TerritoryUser/"+removeuserId, {
            headers: headers_n
        })
            .toPromise()
            .then(res => res);
    }



    getComment(objectId) {
        let randomstr = localStorage.getItem("randomstr");
        let headers_n = new HttpHeaders({
            'organizationId': this.user.organizationId + ''
            ,
            'userId': this.user.userId + '',
            // 'loginAuditId': this.user.loginAuditId + '',
            //  'authToken': this.user.token + '',
            // 'sessionId': randomstr,
            // 'sourceType': 'Web'
        });
        return this.http.get<any>(this.activityUrl+'/LionO360/2.0/API/ObjectNote?objectId='+objectId+'&objectTypeId=5', {
            headers: headers_n
        })
            .toPromise()
            .then(res => res);
    }

    updateComment(objectId) {
        let randomstr = localStorage.getItem("randomstr");
        let headers_n = new HttpHeaders({
            'organizationId': this.user.organizationId + ''
            ,
            'userId': this.user.userId + '',
            // 'loginAuditId': this.user.loginAuditId + '',
            //  'authToken': this.user.token + '',
            // 'sessionId': randomstr,
            // 'sourceType': 'Web'
        });
        return this.http.put<any>(this.activityUrl+'/LionO360/2.0/API/Note', objectId, {
            headers: headers_n
        })
            .toPromise()
            .then(res => res);
    }

    deleteComment(objectId) {
        let randomstr = localStorage.getItem("randomstr");
        let headers_n = new HttpHeaders({
            'organizationId': this.user.organizationId + ''
            ,
            'userId': this.user.userId + '',
            // 'loginAuditId': this.user.loginAuditId + '',
            //  'authToken': this.user.token + '',
            // 'sessionId': randomstr,
            // 'sourceType': 'Web'
        });
        return this.http.delete<any>(this.activityUrl+'/LionO360/2.0/API/Note/'+objectId , {
            headers: headers_n
        })
            .toPromise()
            .then(res => res);
    }

    getTerrioryById(territoryId,isEdit=true) {

        let headers_n = new HttpHeaders({
            'organizationId': this.user.organizationId + ''
            ,
            'userId': this.user.userId + '',
            // 'loginAuditId': this.user.loginAuditId + '',
            //  'authToken': this.user.token + '',
            // 'sessionId': randomstr,
            // 'sourceType': 'Web'
        });
        return this.http.get<any>(this.territoryurl+'Territory/' + territoryId+"?isEdit="+isEdit, {
            headers: headers_n
        })
            .toPromise()
            .then(res => res);
    }

    getLeadById(leadId) {
        let headers_n = new HttpHeaders({
            'organizationId': this.user.organizationId + ''
            ,
            'userId': this.user.userId + '',
            // 'loginAuditId': this.user.loginAuditId + '',
            //  'authToken': this.user.token + '',
            // 'sessionId': randomstr,
            // 'sourceType': 'Web'
        });
        return this.http.get<any>(this.leadAPI + leadId,{

            headers: headers_n
        })
            .toPromise()
            .then(res => res);
    }

    getLeadCountry() {
        let headers_n = new HttpHeaders({
            'organizationId': this.user.organizationId + ''
            ,
            'userId': this.user.userId + '',
            // 'loginAuditId': this.user.loginAuditId + '',
            //  'authToken': this.user.token + '',
            // 'sessionId': randomstr,
            // 'sourceType': 'Web'
        });
        return this.http.get<any>(this.territoryurl + 'Territory/CountryByLead',{

            headers: headers_n
        })
            .toPromise()
            .then(res => res);
    }

    getCountryByAccount(templateId){
        return  this.http.get<any>(`${environment.apiUrlAccount}Account/CountryByAccount?typeId=${templateId}`)
        .toPromise()
        .then(res => res);
    }

    getCountryByLead(templateId){
        return  this.http.get<any>(`${environment.apiUrlNew}Lead/CountryByLead?typeId=${templateId}`)
        .toPromise()
        .then(res => res);
    }

    getAccountCountry(templateID) {
        let headers_n = new HttpHeaders({
            'organizationId': this.user.organizationId + ''
            ,
            'userId': this.user.userId + '',
            // 'loginAuditId': this.user.loginAuditId + '',
            //  'authToken': this.user.token + '',
            // 'sessionId': randomstr,
            // 'sourceType': 'Web'
        });
        return this.http.get<any>(this.territoryurl + 'Territory/CountryByAccount?typeId='+templateID,{

            headers: headers_n
        })
            .toPromise()
            .then(res => res);
    }

    getAccountById(accountId) {
        let headers_n = new HttpHeaders({
            'organizationId': this.user.organizationId + ''
            ,
            'userId': this.user.userId + '',
            // 'loginAuditId': this.user.loginAuditId + '',
            //  'authToken': this.user.token + '',
            // 'sessionId': randomstr,
            // 'sourceType': 'Web'
        });
        return this.http.get<any>( environment.apiUrlAccount +  'Account/' + accountId,{

            headers: headers_n
        })
            .toPromise()
            .then(res => res);
    }

    getAllStages() {
        return this.http.get<any>(this.appUrl + 'ContactStages/')
            .toPromise()
            .then(res => res);
    }

    getAllTerri() {
        return this.http.get<any>(this.appUrl + 'territories')
            .toPromise()
            .then(res => res);
    }
    getRootTerri(currentUserId) {
        let headers_n = new HttpHeaders({
            'organizationId': this.user.organizationId + ''
            ,
          'userId': this.user.userId + '',
            // 'loginAuditId': this.user.loginAuditId + '',
            //  'authToken': this.user.token + '',
            // 'sessionId': randomstr,
            // 'sourceType': 'Web'
        });
        return this.http.get<any>(this.territoryurl+'Territory?loginUserId='+currentUserId+'&PageNumber=0&PageSize=0&SearchValue=Active&SearchColumns=status&SortBy=Name&IsAscending=true&organizationId='+this.user.organizationId, {
            headers: headers_n
        })
            .toPromise()
            .then(res => res);
    }

    getallTerritoryAccounts(templateId,pageNumber,pageSize,searchValue) {

        let headers_n = new HttpHeaders({
            'organizationId': this.user.organizationId + ''
            ,
          'userId': this.user.userId + '',
            // 'loginAuditId': this.user.loginAuditId + '',
            //  'authToken': this.user.token + '',
            // 'sessionId': randomstr,
            // 'sourceType': 'Web'
        });
        let url= '&SearchValue='+searchValue+'&SearchColumns=businessName&loginUserId='+this.user.loginAuditId+'&typeId='+templateId+'&stageId=0&pageNumber='+pageNumber+'&pageSize='+pageSize+'&filter=allaccounts&isActive=true&objectNameList=status&objectNameList=childaccounts&parentAccountId=0&SortBy=createdDate&IsAscending=false'
        let urls = this.accountApiUrl + 'TerrritoryAccount?organizationId='+this.user.organizationId+ url;

        return this.http.get<any>(urls, {
          headers:  headers_n,
          observe: 'response'
        })
          .toPromise()
          .then(res =>

          ({
            contacts: res.body,
            headers: JSON.parse(res.headers.get('x-pagination')) //{TotalCount: 91, PageSize: 10, CurrentPage: 1, TotalPages: 10, HasNext: true, HasPrevious: false}
          })

          );
      }
    getTreeTerri(parentId,isAdmin,searchfilter,loginId,searchvalue,pagenumber,options?) {
        let randomstr = localStorage.getItem("randomstr");
        let headers_n = new HttpHeaders({
            organizationId: `${this.user.organizationId}`,
            userId: `${this.user.userId}`,
            loginAuditId: `${this.user.loginAuditId}`,
            authToken: `${this.user.token}`,
            sessionId: `${randomstr}`,
            sourceType: `${'Web'}`
        }), observe : 'response';

        if (options) {
            if (options.sort) {
                return this.http.get<any>(this.territoryurl+'Territory/All?filters='+searchfilter+'&parentTerritoryId='+parentId+'&IsAdmin='+isAdmin+'&PageNumber='+pagenumber+'&PageSize=15&SortBy='+options.sort.SortBy+'&SearchColumns=&IsAscending='+options.sort.IsAscending+'&SearchValue='+searchvalue, {
                    headers: headers_n, observe : 'response'
                })
                    .toPromise()
                    .then(res =>  ({
                        terrilist: res.body,
                        headers : JSON.parse(res.headers.get('X-Pagination'))
                    })   );
            }
            else
            {
                return this.http.get<any>(this.territoryurl+'Territory/All?filters='+searchfilter+'&parentTerritoryId='+parentId+'&IsAdmin='+isAdmin+'&PageNumber='+pagenumber+'&PageSize=15&SortBy=CreatedDate&SearchColumns=&IsAscending=false&SearchValue='+searchvalue, {
                    headers: headers_n, observe : 'response'
                })
                    .toPromise()
                    .then(res =>  ({
                        terrilist: res.body,
                        headers : JSON.parse(res.headers.get('X-Pagination'))
                    })   );
            }
          }
    }

    getNewTreeTerri(parentId,isActive,searchfilter,loginId,searchvalue,pagenumber,options?,firstCountryId=0) {
        let randomstr = localStorage.getItem("randomstr");
        let headers_n = new HttpHeaders({
            organizationId: `${this.user.organizationId}`,
            userId: `${this.user.userId}`,
            loginAuditId: `${this.user.loginAuditId}`,
            authToken: `${this.user.token}`,
            sessionId: `${randomstr}`,
            sourceType: `${'Web'}`
        }), observe : 'response';

        if (options) {
            if (options.sort) {
                debugger;
                return this.http.get<any>(this.territoryurl+'Territory/AllNew?filters='+searchfilter+'&countryId='+firstCountryId+'&parentTerritoryId='+parentId+'&isActive='+isActive+'&PageNumber=0&PageSize=0&SortBy='+options.sort.SortBy+'&IsAscending='+options.sort.IsAscending+'&SearchValue='+searchvalue, {
                    headers: headers_n, observe : 'response'
                })
                    .toPromise()
                    .then(res =>  ({
                        terrilist: res.body,
                        headers : JSON.parse(res.headers.get('X-Pagination'))
                    })   );
            }
            else
            {
                return this.http.get<any>(this.territoryurl+'Territory/AllNew?filters='+searchfilter+'&countryId='+firstCountryId+'&parentTerritoryId='+parentId+'&isActive='+isActive+'&PageNumber=0&PageSize=0&SortBy=CreatedDate&&IsAscending=false&SearchValue='+searchvalue, {
                    headers: headers_n, observe : 'response'
                })
                    .toPromise()
                    .then(res =>  ({
                        terrilist: res.body,
                        headers : JSON.parse(res.headers.get('X-Pagination'))
                    })   );
            }
          }
    }
    updateTerri(c) {
        return this.http.put<any>(this.appUrl + 'territories/' + c.id, c)
            .toPromise()
            .then(res => res);
    }
    getAssignTerri(territoryId,pageSize,pageNumber,searchValue="",searchColumns="",sortBy="",isAscending=true) {

        let url = this.territoryurl + 'Territory/'+territoryId+'/AssignedObjects?PageNumber='+pageNumber+'&PageSize='+pageSize+'&IsAscending='+isAscending+'&isActive=true';

        if(sortBy){
            url = url + '&SortBy='+sortBy;
        }else{
            url = url + '&SortBy=CreatedDate';
        }

        if(searchValue){
            url = url + '&SearchValue='+searchValue;
        }

        if(searchColumns){
            url = url + '&SearchColumns='+searchColumns;
        }else{
            url = url + '&SearchColumns=businessName';
        }

       return this.http.get<any>(url,{observe : 'response'})
        .toPromise()
        .then(res =>  ({
            contacts: res.body,
            headers : JSON.parse(res.headers.get('X-Pagination'))
        }));

    }
    getlat(add : any) {
        return this.http.get<any>(terriEnum.mapurl +add + '&key='+terriEnum.mapkey)
            .toPromise()
            .then(res => res);
    }
    getAllCountries() {
        return this.http.get<any>(environment.apiUrl + 'Country')
            .toPromise()
            .then(res => res);
    }

    getFieldData(){
        return this.http.get<any>(`${environment.configUrl}LionO360_ObjectFieldDisplay?objectId=5&categoryId=18`);
    }

    ruleTerritoryList(moduleId: number = 0, channelId: number = 0) {
        let headers_n = new HttpHeaders({
            'organizationId': this.user.organizationId + '',
            'userId': this.user.userId + ''
        });

        const params = new HttpParams()
        .append("moduleId", `${moduleId}`)
        .append("channelId", `${channelId}`)

        return this.http.get<any>(this.territoryurl+'Territory/Rule/TerritoryList', {
            headers: headers_n,
            params: params
        });
    }

    childTerritoryList(parentId) {
        let headers_n = new HttpHeaders({
            'organizationId': this.user.organizationId + '',
            'userId': this.user.userId + ''
        });
        return this.http.get<any>(`${this.territoryurl}Territory/ChildTerritory?parentTerritoryId=${parentId}`, {
            headers: headers_n
        });
    }

    getAllTerritoryies(channelId: number, isActive: boolean) {
        const params = new HttpParams()
        .append("isActive", `${isActive}`)
        .append("channelId", `${channelId}`)

        return this.http.get<any>(`${this.territoryurl}Territory/AllTerritory`, { params: params });
    }

    getChildTerritoryies(countryId: number, moduleId: number, channelId: number) {
        const params = new HttpParams()
        .append("countryId", `${countryId}`)
        .append("TypeId", `${moduleId}`)
        .append("ChannelId", `${channelId}`)

        return this.http.get<any>(`${this.territoryurl}Territory/ChildrenTerritory`, { params: params });
    }

    getTerritoryConfigurations(){
        return this.http.get<any>( `${environment.configUrl}Configuration/ConfigurationsByModuleName?name=Territory`)

    }

    addRootTerritory(rootDetails: AddRootTerritory){
        return this.http.post(`${this.territoryurl}Territory/Root`,rootDetails);
    }

    updateRootTerritory(rootDetails: AddRootTerritory){
        return this.http.put(`${this.territoryurl}Territory/Root`,rootDetails);
    }

    getTerritoryMapObjects(territoryId: number){
        return this.http.get(`${this.territoryurl}Territory/${territoryId}/AssignedObjectsForMap`);
    }

    getRootTerritoryDetails(territoryId: number){
        return this.http.get(`${this.territoryurl}Territory/Root/${territoryId}`);
    }
}
